var light = {
  palette: {
    primary: {
      light: '#ffcf88',
      main: '#f89406',
      dark: '#b5740b',
      contrastText: '#000',
    },
    secondary: {
      main: '#333333',
    },
    background: {
      light: '#ffffff',
      main: '#fafafa',
      dark: '#f2f2f2',
    },
    error: {
      main: '#d91e18',
    }
  },
}

export default light;



// WEBPACK FOOTER //
// ./src/themes.js